import Dodge from '@carvana/ds-icons/Dodge';
import DodgeHorizontal from '@carvana/ds-icons/DodgeHorizontal';
import cx from 'classnames';

type OwnProps = React.ComponentProps<typeof Dodge> & {
  arrowUsesFill?: boolean;
  orientation?: 'horizontal' | 'vertical';
};

const FILL_OVERRIDE_CLASSES = cx(
  '[&>path:first-child]:fill-[var(--dodge-text-fill)]',
  '[&>path:not(:first-child)]:fill-[var(--dodge-arrow-fill)]'
);

export default function DodgeIcon({
  arrowUsesFill = false,
  className,
  color,
  orientation = 'horizontal',
  style,
  ...props
}: OwnProps) {
  const Icon = orientation === 'vertical' ? Dodge : DodgeHorizontal;
  const textFill = color ?? '#231F20';
  const arrowFill = arrowUsesFill ? textFill : '#E1251B';

  return (
    <Icon
      className={cx(FILL_OVERRIDE_CLASSES, className)}
      style={
        {
          ...style,
          '--dodge-text-fill': textFill,
          '--dodge-arrow-fill': arrowFill
        } as React.CSSProperties
      }
      {...props}
    />
  );
}
